import { Typography } from "@mui/material";
import { InvalidRouteBase } from "features/shell";

export default function CalculationNotExist() {
  return (
    <InvalidRouteBase>
      <Typography>
        Your link may be broken or the calculation may have been removed.
      </Typography>
    </InvalidRouteBase>
  );
}
